import * as SelectPrimitive from "@radix-ui/react-select";
import * as React from "react";

import { cn } from "../../../utils";
import { CommandSeparator } from "../../Command";
import { SelectContext } from "./context";

export function SelectSeparator({
  className,
  ...props
}: React.ComponentPropsWithoutRef<typeof SelectPrimitive.Separator>) {
  const ctx = React.useContext(SelectContext);

  if (ctx.isSimple) {
    return (
      <SelectPrimitive.Separator
        className={cn("-mx-1 my-1 h-px bg-gray-100", className)}
        {...props}
      />
    );
  }

  return <CommandSeparator className={cn("-mx-1 my-1", className)} />;
}

SelectSeparator.displayName = SelectPrimitive.Separator.displayName;
